export default "/list/static/images/map-marker.png";